module.exports = __webpack_public_path__ + "static/img/banner_solutions_servo.dafdb3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/banner_solutions_servo.png
// module id = yidt
// module chunks = 10